import React from 'react';
import gql from 'graphql-tag';
import { ShopTaxPoliciesData } from '../../../schemas/rql';
import ShopTaxPoliciesInternal from './shop_tax_policies_internal';

interface Props {
  shop: ShopTaxPoliciesData.Fragment;
}

export const ShopTaxPoliciesFragment = gql`
  fragment ShopTaxPoliciesData on Shop {
    _id
    taxPolicies {
      displayLocation
      displayRate
      policyType
    }
  }
`;

export default function ShopTaxPolicies({ shop }: Props) {
  if (!shop) return null;

  return (<ShopTaxPoliciesInternal taxPolicies={shop.taxPolicies} />);
}
